export const SET_PUBLICASKING = 'ROOM/PUBLICASKING/SET_PUBLICASKING'
export const SET_PUBLICASKINGS = 'ROOM/PUBLICASKING/SET_PUBLICASKINGS'
